import { createFileRoute } from '@tanstack/react-router';

import { RouteGuard } from '../../lib/route-guard.js';

export const Route = createFileRoute('/accounts-receivable')({
  component: () => <RouteGuard route="/accounts-receivable" />,
});
